import { Box, Button, CircularProgress, FormControl, IconButton, Modal, TextField, Typography } from '@mui/material';
import styles from './NewOfficeModal.module.css';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { GetOffice_Out, OfficesService } from 'src/pehra-ts-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export interface INewOfficesModal {
  openModal: boolean;
  handleCloseModal: () => void;
  parentOfficeDetail: GetOffice_Out | null;
}

type TFormData = {
  parent_office_id: string | null;
  office_name: string;
};

const NewOfficesModal: React.FC<INewOfficesModal> = ({ openModal, handleCloseModal, parentOfficeDetail }) => {
  const [formData, setFormData] = useState<TFormData>({
    parent_office_id: parentOfficeDetail?.id || null,
    office_name: ''
  });

  const queryClient = useQueryClient();

  const addOffice = async () => {
    try {
      const res = await OfficesService.addOffice(formData);
      return res;
    } catch (error) {
      throw error;
    }
  };

  const addOfficeMutation = useMutation({
    mutationFn: addOffice,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['officesList', parentOfficeDetail?.id || null]
      });
      queryClient.invalidateQueries({
        queryKey: ['officeTree']
      });
      handleCloseModal();
    }
  });

  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSaveClick = (e: any) => {
    e.preventDefault();
    //  check if the form is valid
    if (formData.office_name === '') {
      alert('Please enter office name');
    }
    addOfficeMutation.mutate();
  };

  useEffect(() => {
    setFormData({
      parent_office_id: parentOfficeDetail?.id || null,
      office_name: ''
    });
  }, [parentOfficeDetail]);

  const modalContent = (
    <form onSubmit={handleSaveClick}>
      <FormControl
        sx={{
          width: '100%'
        }}
      >
        <Box style={{ padding: '20px' }}>
          <Typography variant="h6">Office Name</Typography>
          <TextField
            className={styles.input}
            type="text"
            placeholder="Enter office name"
            name="office_name"
            onChange={handleFormChange}
            required={true}
          />
        </Box>
        {addOfficeMutation.isPending && (
          <Box style={{ padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant="h6">Saving...</Typography>
            <CircularProgress />
          </Box>
        )}
        <Box>
          <Button type="submit" variant="contained" color="primary" style={{ margin: '20px' }} fullWidth>
            Save
          </Button>
        </Box>
      </FormControl>
    </form>
  );

  return (
    <Modal open={openModal} onClose={handleCloseModal}>
      <Box className={styles.modalContainer}>
        <IconButton onClick={handleCloseModal} style={{ position: 'absolute', right: '10px', top: '10px' }}>
          <CloseIcon />
        </IconButton>
        <Box>
          <Typography variant="h4" style={{ padding: '20px' }}>
            New Office Details{parentOfficeDetail ? ` under ${parentOfficeDetail.office_name}` : ''}
          </Typography>
        </Box>
        {modalContent}
      </Box>
    </Modal>
  );
};

export default NewOfficesModal;
